module.exports = __webpack_public_path__ + "img/file-earmark-music-fill.2f60e383.svg";